<template>
    <b-row>
        <div class="col-sm-6 mt-3">
            <label for="" class="form-label">Sucursal</label>
            <select class="form-control form-control-sm" v-model="sucursal">
                <option value="">Seleccionar</option>
                <option v-for="(item, index) in sucursales" :key="index" :value="item.codigo">{{ item.nombre }}</option>
            </select>
        </div>
        <div class="col-sm-2 mt-3">
            <label for="" class="form-label">Fecha incial</label>
            <input type="date" class="form-control form-control-sm" v-model="fecha_inicial">
        </div>
        <div class="col-sm-2 mt-3">
            <label for="" class="form-label">Fecha final</label>
            <input type="date" class="form-control form-control-sm" v-model="fecha_final">
        </div>
        <div class="col-sm-2 mt-5">
            <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                @click="consulta_bitacora">Buscar</button>
        </div>
        <div class="col-sm-12 mt-3">
            <div class="marco_bitacora">

                <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                    <thead>
                        <tr>
                            <th style="width: 10%;text-align: center;">
                                Fecha
                            </th>
                            <th style="width: 10%;text-align: center;">
                                Serie
                            </th>
                            <th style="width: 10%;text-align: center;">
                                Número
                            </th>
                            <th style="width: 35%;text-align: center;">
                                Nombre
                            </th>
                            <th style="width: 15%;text-align: center;">
                                Sucursal
                            </th>
                            <th style="width: 10%;text-align: center;">
                                Tipo de documento
                            </th>
                            <th style="width: 10%;text-align: center;">
                                Total
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in datos.datos" :key="index">
                            <td style="text-align: center;">
                                {{ item.fecha_movimiento }}
                            </td>
                            <td style="text-align: center;">
                                {{ item.sat_serie }}
                            </td>
                            <td style="text-align: center;">
                                {{ item.sat_numero }}
                            </td>
                            <td>
                                {{ item.nombre_cliente }}
                            </td>
                            <td style="text-align: center;">
                                {{ item.nombre_sucursal }}
                            </td>
                            <td style="text-align: center;">
                                {{ item.sat_tipo_documento }}
                            </td>
                            <td style="text-align: center;">
                                Q{{ item.total_movimiento.toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) }}
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td style="text-align: center;">Gran total</td>
                            <td style="text-align: center;">Q{{ gran_total.toLocaleString(undefined, {
                                minimumFractionDigits: 2, maximumFractionDigits: 2
                            }) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </b-row>
</template>

<script>
    import { minix } from '@/components/functions/alertas';
    import moment from 'moment';
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'Bitacora',
        computed: {
            ...mapState(['sucursales', 'id_empresa_seleccionada'])
        },
        data() {
            return {
                sucursal: '',
                fecha_inicial: moment(Date.now()).format('YYYY-MM-DD'),
                fecha_final: moment(Date.now()).format('YYYY-MM-DD'),
                datos: {},
                gran_total: 0
            }
        },
        methods: {
            async consulta_bitacora() {
                if (this.sucursal == '' || this.fecha_inicial == '' || this.fecha_final == '') {
                    minix({ icon: 'info', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })
                } else {
                    let f = {
                        api: `movimientos-detalles/c/bitacora?fecha_inicial=${this.fecha_inicial}&fecha_final=${this.fecha_final}&sucursal=${this.sucursal}&empresa=${this.id_empresa_seleccionada}`
                    }

                    let r = await this.obtener_data(f)
                    if (r.datos.length == 0) {
                        minix({ icon: 'info', mensaje: 'No se encontraron registros', tiempo: 3000 })
                    } else {

                        this.datos = r
                        this.gran_total = r.total
                    }
                }
            },
            ...mapActions(['obtener_data'])
        },
    }
</script>

<style>
    .marco_bitacora {
        width: 100%;
        height: calc(100vh - 230px);
        overflow: auto;
    }
</style>